export const AdminHome = () => <div>Hello, Admin</div>;